var render = function render(_c,_vm){return (_vm.icon)?_c('i',{class:`shipping-type shipping-type--${_vm.icon}`}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }